import { motion } from "framer-motion";
import { MoodTracker } from "@/components/Wellness/MoodTracker";
import { SpendingHabitsChecklist } from "@/components/Wellness/SpendingHabitsChecklist";
import { SubscriptionDetector } from "@/components/Wellness/SubscriptionDetector";
import { WellnessInsights } from "@/components/Wellness/WellnessInsights";
import { PageHeader } from "@/components/ui/page-header";
import { Heart, Brain, Sparkles } from "lucide-react";

const Wellness = () => {
  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl space-y-6">
      <PageHeader
        icon={Heart}
        iconClassName="from-primary/15 to-primary/5"
        title="Financial Wellness"
        description="Understanding the connection between your emotions and finances"
      />

      {/* Main Grid */}
      <div className="grid gap-6 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="space-y-6"
        >
          <MoodTracker />
          <SpendingHabitsChecklist />
          <SubscriptionDetector />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
          className="space-y-6 self-start sticky top-6"
        >
          <WellnessInsights />
        </motion.div>
      </div>

      {/* Info Box */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        className="p-6 bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 rounded-2xl border border-primary/20"
      >
        <div className="flex items-start gap-4">
          <div className="p-3 bg-primary/15 rounded-xl flex-shrink-0">
            <Brain className="h-5 w-5 text-primary-text" />
          </div>
          <div>
            <h3 className="text-base font-semibold flex items-center gap-2">
              Psychology-Informed Finance
              <Sparkles className="h-4 w-4 text-primary-text" />
            </h3>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
              Research shows that emotional states significantly impact spending decisions.
              By tracking your mood alongside your finances, you can identify patterns like
              stress shopping or emotional spending, and build healthier financial habits.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Wellness;
